import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img 
              src="/favicon.svg" 
              alt="Autonomerly Logo" 
              style={{ 
                width: '40px', 
                height: '40px',
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '4px'
              }} 
            />
            <span style={{ fontSize: '1.5rem', fontWeight: '800', color: 'var(--primary-color)' }}>
              Autonomerly
            </span>
          </Link>
          <nav className="nav">
            {/* Navigation items can be added here in the future */}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
